(function(){
"use strict";
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
function rand(a,b){return Math.floor(Math.random()*(b-a+1))+a}
function pick(a){return a[Math.floor(Math.random()*a.length)]}
function imgu(u,w){if(!u)return u;if(u.indexOf("cdn.shopify.com")<0&&u.indexOf("/cdn/")<0)return u;return u+(u.indexOf("?")>-1?"&":"?")+"width="+w}

/* header shrink */
var hd=$(".hd");if(hd)addEventListener("scroll",function(){hd.classList.toggle("shrink",scrollY>40)},{passive:true});
/* mobile menu */
document.addEventListener("click",function(e){
 if(e.target.closest(".menu-btn")){var m=$(".mobnav");if(m)m.classList.add("open")}
 if(e.target.closest(".mobnav .cl")){var m2=$(".mobnav");if(m2)m2.classList.remove("open")}
 if(e.target.closest(".mobnav a")){var m3=$(".mobnav");if(m3)m3.classList.remove("open")}
});

/* hero slider */
(function(){var s=$$(".hs");if(s.length<2)return;var d=$$(".hs-dot"),i=0,t;
 function go(n){s[i].classList.remove("on");if(d[i])d[i].classList.remove("on");i=(n+s.length)%s.length;s[i].classList.add("on");if(d[i])d[i].classList.add("on")}
 function reset(){clearInterval(t);t=setInterval(function(){go(i+1)},5500)}
 d.forEach(function(b,k){b.addEventListener("click",function(){go(k);reset()})});
 var pv=$(".hs-ar.prev"),nx=$(".hs-ar.next");if(pv)pv.onclick=function(){go(i-1);reset()};if(nx)nx.onclick=function(){go(i+1);reset()};
 var h=$(".hslider");if(h){h.addEventListener("mouseenter",function(){clearInterval(t)});h.addEventListener("mouseleave",reset)}
 reset();
})();

/* cart count */
function cartCount(){fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}).then(function(c){$$("[data-cart-count]").forEach(function(e){e.textContent=c.item_count;e.style.display=c.item_count?"flex":"none"})}).catch(function(){})}
cartCount();

/* product interactions */
(function(){
 var pdp=$("[data-product]");if(!pdp)return;
 var idInput=$('select[name=id],input[name=id]',pdp);
 var variants=window.__variants||[];
 $$(".sz",pdp).forEach(function(b){b.addEventListener("click",function(){$$(".sz",pdp).forEach(function(x){x.classList.remove("on")});b.classList.add("on");var vid=b.getAttribute("data-vid");if(vid&&idInput)idInput.value=vid})});
 $$(".thumbs img",pdp).forEach(function(t){t.addEventListener("click",function(){$("#pmain").src=t.getAttribute("data-full")||t.src;$$(".thumbs img",pdp).forEach(function(x){x.classList.remove("on")});t.classList.add("on")})});
 var qi=$("#qtyv",pdp);
 $$("[data-q]",pdp).forEach(function(b){b.addEventListener("click",function(){var v=(parseInt(qi.value,10)||1)+(b.getAttribute("data-q")==="+"?1:-1);qi.value=v<1?1:v})});
 var buy=$("#buyBtn",pdp),buy2=$("#buyBtn2");
 function doBuy(){var id=idInput?idInput.value:null;var q=parseInt(qi&&qi.value,10)||1;if(!id)return;fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:id,quantity:q})}).then(function(){location.href="/checkout"})}
 if(buy)buy.addEventListener("click",doBuy);
 if(buy2)buy2.addEventListener("click",doBuy);
 var af=$("#product-form"),ab2=$("#addBtn2");if(af&&ab2)ab2.addEventListener("click",function(){if(af.requestSubmit)af.requestSubmit();else af.submit()});
 var ln=$("#liveN",pdp);if(ln)setInterval(function(){ln.textContent=rand(15,72)},10000);
})();

/* sold popups */
(function(){
 return; // sold popup disabled
 var NAMES=["Ayesha","Fatima","Zainab","Bilal","Hamza","Sara","Noor","Ali","Maryam","Usman","Hina","Ahmed","Iqra","Saad"];
 var CITIES=["Karachi","Lahore","Islamabad","Rawalpindi","Faisalabad","Multan","Peshawar","Hyderabad"];
 var P=[];
 fetch("/products.json?limit=40").then(function(r){return r.json()}).then(function(d){P=(d.products||[]).filter(function(p){return p.images&&p.images.length}).map(function(p){return{title:p.title,img:p.images[0].src}});if(P.length)loop()});
 var box;
 function ensure(){box=document.createElement("div");box.className="sold";document.body.appendChild(box)}
 function show(){if(!P.length)return;if(!box)ensure();var p=pick(P);var txt=rand(0,1)?("<b>"+pick(NAMES)+"</b> in "+pick(CITIES)+" bought<br><b>"+p.title+"</b>"):("<b>"+rand(3,14)+" people</b> bought <b>"+p.title+"</b>");var mins=pick(["8 minutes ago","23 minutes ago","1 hour ago","2 hours ago","3 hours ago","today"]);box.innerHTML='<img src="'+imgu(p.img,140)+'" alt="" loading="lazy"><div class="t">'+txt+'<div class="m">'+mins+' · verified</div></div><button class="x" aria-label="close">&times;</button>';box.querySelector(".x").onclick=function(){box.classList.remove("show")};box.classList.add("show");setTimeout(function(){box.classList.remove("show")},5000)}
 function loop(){setTimeout(function run(){show();setTimeout(run,rand(9000,14000))},4000)}
})();
})();
